import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CSpinner } from '@coreui/react';

// Components ko import karein (Raste sahi check karein)
import Login from './views/pages/Login'; 
import Register from './views/pages/Register';
import MembershipLayout from './layout/MembershipLayout'; // Bina { } ke hona chahiye
import MembershipStore from './views/membership/MembershipStore';
import Home from './views/membership/Home';
import CourseDetails from './views/membership/CourseDetails';
// CoreUI CSS zaroori hai
import '@coreui/coreui/dist/css/coreui.min.css';
import ViewQuestion from './views/membership/ViewQuestion';
import DownloadPDF from './components/DownloadPDF';
import CoursePage from './views/membership/CoursePage';
import QuestionBank from './views/membership/QuestionBank';
import YearWiseQuestionBank from './views/membership/YearWiseQuestionBank'
import YearSpecificQuestionBank from './views/membership/YearSpecificQuestionBank';
import ChapterWiseQuestionBank from './views/membership/ChapterWiseQuestionBank';
import TopicQuestionsList from './views/membership/TopicQuestionsList';
import BookSolution from './views/membership/BookSolution';
import ExerciseQuestions from './views/membership/ExerciseQuestions';
import UserProfile from './views/membership/UserProfile';
import ChapterTopicView from './views/membership/ChapterTopicView'; // Import ChapterTopicView
import NotesPage from './views/membership/NotesPage';
import NotesQuestionsList from './views/membership/NotesQuestionsList'; // Import NotesQuestionsList
const App = () => {
  return (
    <BrowserRouter>
      {/* Suspense ka use karein taaki loading smooth ho */}
      <Suspense fallback={<CSpinner color="primary" />}>
      <Routes>
        {/* Auth Pages */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Layout Wrapper */}
        <Route element={<MembershipLayout />}>
               <Route path="/" element={<Home/>} />
          <Route path="/membership" element={<MembershipStore />} />
          {/* <Route path="/:section/:title" element={<CourseDetails />} /> */}
         <Route path="/:section/:title" element={<QuestionBank />} />
<Route path="/:section/:title/year-wise" element={<YearWiseQuestionBank />} />
<Route path="/:section/:title/year-wise/:year" element={<YearSpecificQuestionBank />} />
<Route path="/:section/:title/chapter-wise" element={<ChapterWiseQuestionBank />} />
<Route path="/:section/:title/notes" element={<NotesPage />} />
<Route path="/:section/:title/topic/:topicSlug" element={<TopicQuestionsList />} />
<Route path="/:section/:title/book-solutions" element={<BookSolution/>} />
<Route path="/:category/:chapter/exercise-questions/:exerciseNo" element={<ExerciseQuestions />} />
<Route path="/:section/:title/notes/:noteId/:chapterName/:topicName" element={<NotesQuestionsList />} />
{/* <Route path="/:section/:title/chapter-wise/:chapter" element={<YearSpecificQuestionBank />} /> */}
          <Route path="/content/view-question/:id/:text" element={<ViewQuestion/>} />
          <Route path="/content/download-pdf/:id" element={<DownloadPDF />} />
          <Route path="/" element={<Navigate to="/" replace />} />
          <Route path="/course/:courseName" element={<CoursePage />} />
          <Route path="/profile" element={<UserProfile />} />
           {/* <Route path="/course/:courseName" element={<QuestionBank />} /> */}
            {/* <Route path="/question" element={<QuestionBank />} /> */}
          
           {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Route>
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;